import { z } from 'zod';

export const RawUIFolderSchema = z.object({ name: z.string() });
